<template lang="pug">
.index_page.page(:class="!isYd && 'is-not_yd'")
  j-tab.voice-tabs.color_bg_1(
    ref="tabEle",
    :isStudy="isStudyMode",
    @j-tab-switch="tabSwitch",
    @j-switch-study="studyModeSwitch",
    :style="isYd?`padding-top: ${statusBarHeight}px;`:''"
  )
  .voice-pics#voicePics(:style="isYd?`padding-top:${tabHeight}px`:''")
    Voiceless(v-if="voiceType === 'voiceless'", :showTypes="showTypes", :isStudyMode="isStudyMode")
    Hard(v-if="voiceType === 'hard'", :showTypes="showTypes")
    Turbid(v-if="voiceType === 'turbid'", :showTypes="showTypes")
</template>

<script>
// @ is an alias to /src
import {
  ref,
  provide,
  onMounted,
  nextTick,
  getCurrentInstance,
} from 'vue';
import Voiceless from '@/components/Voiceless.vue';
import Hard from '@/components/Hard.vue';
import Turbid from '@/components/Turbid.vue';
import JTab from '@/components/JTab.vue';

export default {
  name: 'Index',
  components: {
    Voiceless,
    JTab,
    Hard,
    Turbid,
  },
  setup() {
    const currentInstance = getCurrentInstance();
    const isStudyMode = ref(false); // 是否为学习模式
    const voiceType = ref('voiceless'); // 'voiceless', 'turbid', 'hard'
    const showTypes = ref(['hiragana', 'katakana', 'romaji']);
    const isYd = ref(false); // 词典客户端环境
    const statusBarHeight = ref(20);
    const tabHeight = ref('');

    // 清音、浊音、拗音tab切换
    const tabSwitch = (selectedTab) => {
      console.log('tabSwitch==', selectedTab);
      showTypes.value = selectedTab.sub;
      voiceType.value = selectedTab.main;
      isStudyMode.value = false;
      // eslint-disable-next-line
      window._rlog.push([
        '_trackCustom',
        'japanese50',
        [
          ['show', 'syllabary_homepage'],
          ['type', selectedTab.main],
        ],
      ]);
    };

    // 平假名、片假名、罗马音tab切换
    const studyModeSwitch = (studyMode) => {
      isStudyMode.value = studyMode;
      // eslint-disable-next-line
      window._rlog.push([
        '_trackCustom',
        'japanese50',
        [
          ['action', 'syllabary_practice_button'],
        ],
      ]);
    };

    provide('pageStatus', {
      isStudyMode,
      voiceType,
    });

    onMounted(() => {
      nextTick(() => {
        const { tabEle } = currentInstance.refs;
        console.log('tabEle.$el==', tabEle.$el);
        let height = tabEle.$el.getBoundingClientRect().height + 16;
        if (window.ydk) {
          isYd.value = window.ydk.isYD;
          // 通知客户端停止小程序 loading
          window.ydk.stopPageLoading();
          // 获取客户端 statusBarHeight
          window.ydk.getSystemInfo({
            success: (res) => {
              console.log('getSystemInfo==', res);
              if (res.code === 1000) {
                statusBarHeight.value = res.statusBarHeight + 10;
                setTimeout(() => {
                  height = tabEle.$el.getBoundingClientRect().height + 16;
                  tabHeight.value = height;
                  console.log('getSystemInfo height==', height);
                }, 200);
              }
            },
          });
        }
      });
    });

    return {
      isStudyMode,
      showTypes,
      voiceType,
      isYd,
      statusBarHeight,
      tabHeight,
      tabSwitch,
      studyModeSwitch,
    };
  },
};
</script>

<style lang="stylus">
  .index_page
    padding 0.2rem 0
    .voice-pics
      margin 0 0.4rem 0 0.2rem
      padding 2.4rem 0 0.32rem 0
    .voice-tabs
      position fixed
      top 0
      left 0
      right 0
      z-index 2
      padding 0.64rem 0.4rem 0 0.4rem
      background #ffffff url("../assets/bg_jp_gradient@2x.png") 50% 0 no-repeat
      background-size 100% auto
  .is-not_yd
    .voice-tabs
      padding 0.32rem 0.4rem 0 0.4rem
    .voice-pics
      margin 0 0.4rem 0 0.2rem
      padding-top 2.12rem
</style>
<style scoped lang="stylus">
  .dark
    .index_page
      .voice-tabs
        background #141517 url("../assets/bg_jp_gradient_dark@2x.png") 50% 0 no-repeat
        background-size 100% auto
</style>
